export default __webpack_public_path__ + "static/media/upload.bbc61e46.svg";